import { createElementBlock as e, openBlock as o, createElementVNode as l } from "vue";
import t from "./index289.js";
const r = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(s, a, f, i, p, d) {
  return o(), e("svg", n, a[0] || (a[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "currentColor",
        d: "M10.281 18.64a.91.91 0 0 1 .675.182l.882.677a.81.81 0 0 0 .989 0l.915-.704a.81.81 0 0 1 .6-.16l1.146.15a.812.812 0 0 0 .857-.494l.44-1.066c.083-.2.24-.357.44-.44l1.066-.44a.812.812 0 0 0 .495-.857l-.145-1.104a.91.91 0 0 1 .18-.674l.678-.883a.81.81 0 0 0 0-.988l-.704-.916a.81.81 0 0 1-.16-.6l.15-1.146a.812.812 0 0 0-.494-.857l-1.066-.44a.809.809 0 0 1-.44-.44l-.44-1.066a.812.812 0 0 0-.857-.495l-1.145.151a.806.806 0 0 1-.6-.159l-.916-.703a.81.81 0 0 0-.988 0l-.916.703a.818.818 0 0 1-.6.16l-1.146-.15a.812.812 0 0 0-.856.495l-.44 1.065a.82.82 0 0 1-.44.44l-1.066.44a.812.812 0 0 0-.494.857l.15 1.145a.815.815 0 0 1-.16.6l-.703.916a.81.81 0 0 0 0 .988l.703.916a.81.81 0 0 1 .16.6l-.15 1.146a.812.812 0 0 0 .494.856l1.066.441c.2.082.358.24.44.44l.44 1.066c.141.34.493.543.857.494l1.103-.145"
      }),
      l("path", {
        fill: "#FFF",
        "fill-rule": "nonzero",
        d: "M14.155 10.627a.75.75 0 0 1 1.133.977l-.072.084-2.942 2.942a.75.75 0 0 1-.977.072l-.084-.072-1.764-1.765a.75.75 0 0 1 .977-1.133l.084.073 1.233 1.234 2.412-2.412Z"
      })
    ], -1)
  ]));
}
const u = /* @__PURE__ */ t(r, [["render", c]]);
export {
  u as default
};
